import { render, staticRenderFns } from "./documentUpload.vue?vue&type=template&id=497bbf6b&scoped=true&"
import script from "./documentUpload.vue?vue&type=script&lang=js&"
export * from "./documentUpload.vue?vue&type=script&lang=js&"
import style0 from "./documentUpload.vue?vue&type=style&index=0&id=497bbf6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bbf6b",
  null
  
)

export default component.exports